export const shouldOpenOtherTab = (url: string): boolean => {
  if (url.startsWith('/')) {
    return false;
  }
  if (url.startsWith('#')) {
    return false;
  }
  return true;
};
